var DefaultEditorModeManager = require('./default');

function LogoEditorModeManager () {
  this.type = 'logo';

  this.hideList = [
    '#tool-panel .help-menu',
    '.name.editor-header-title',
    '#ruler-horizontal',
    '#ruler-vertical',
    '#ik-grid-snap',
    'header > .tool-size'
  ];
}

LogoEditorModeManager.prototype = new DefaultEditorModeManager();

LogoEditorModeManager.prototype.enableUI = function () {
  DefaultEditorModeManager.prototype.enableUI.call(this);

  $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().hide();
  $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().hide();
};

LogoEditorModeManager.prototype.disableUI = function () {
  DefaultEditorModeManager.prototype.disableUI.call(this);

  $('.tool-menu a[role="tab"][href="#tabAdmin"]').parent().show();
  $('.tool-menu a[role="tab"][href="#tabLayouts"]').parent().show();
};

LogoEditorModeManager.prototype.afterUIEnable = function (data) {
  $('.tool-menu a[role="tab"][href="#tabExtra"]').trigger('click');
  this.editor.canvas.runExtensions('enableRuler', {});
};

module.exports = LogoEditorModeManager;
